import React, { useEffect, useState } from "react";
import MissionReadyRenderer from "./MissionReadyRenderer";
import { useDashboardCarouselSwipe } from "../hooks/useDashboardCarouselSwipe";
import { usePermissions } from "../hooks/usePermissions";
import { CAPABILITY } from "../helpers/permissions";
import { MISSION_CONTROL_MODE } from "../helpers/missionControlSections";
import { useIsDesktopViewport } from "../hooks/useIsDesktopViewport";
import { useDesktopNav } from "./navigation/DesktopNavContext";
import { DesktopBackLink } from "./navigation/ScreenBackButton";
import "./ops/missionDesktop.css";

const TAB_BAR_STYLE = {
  display: "flex",
  gap: "10px",
  padding: "0 18px 16px",
};

const TAB_BUTTON_BASE = {
  flex: 1,
  padding: "12px 14px",
  borderRadius: "12px",
  border: "1px solid rgba(201,168,76,0.25)",
  background: "rgba(255,255,255,0.04)",
  color: "rgba(255,255,255,0.72)",
  fontSize: "12px",
  fontWeight: 700,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  cursor: "pointer",
};

const TAB_BUTTON_ACTIVE = {
  ...TAB_BUTTON_BASE,
  border: "1px solid rgba(201,168,76,0.55)",
  background: "rgba(201,168,76,0.14)",
  color: "#f0d48a",
};

export function MissionControlScreen({
  onBack,
  onCarouselNavigate,
  onOpenNavigator,
}) {
  const { can } = usePermissions();
  const isDesktop = useIsDesktopViewport();
  const desktopNav = useDesktopNav();
  const showDevelopment = can(CAPABILITY.MISSION_CONTROL_DEVELOPMENT);
  const [activeMode, setActiveMode] = useState(
    MISSION_CONTROL_MODE.OPERATIONAL,
  );

  const { ref: carouselRef, style: carouselTouchStyle } =
    useDashboardCarouselSwipe({
      onNavigate: onCarouselNavigate,
      onOpenNavigator,
    });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (
      !showDevelopment &&
      activeMode === MISSION_CONTROL_MODE.DEVELOPMENT
    ) {
      setActiveMode(MISSION_CONTROL_MODE.OPERATIONAL);
    }
  }, [showDevelopment, activeMode]);

  return (
    <div
      ref={carouselRef}
      className={`mission-control-screen${isDesktop ? " mission-control-screen--desk" : ""}`}
      style={carouselTouchStyle}
    >
      {isDesktop && desktopNav && onBack ? (
        <div style={{ marginBottom: 12 }}>
          <DesktopBackLink onClick={onBack} label={desktopNav.parentLabel || "Back"} />
        </div>
      ) : null}
      {showDevelopment && (
        <div style={TAB_BAR_STYLE}>
          <button
            type="button"
            style={
              activeMode === MISSION_CONTROL_MODE.OPERATIONAL
                ? TAB_BUTTON_ACTIVE
                : TAB_BUTTON_BASE
            }
            onClick={() => setActiveMode(MISSION_CONTROL_MODE.OPERATIONAL)}
          >
            Operational
          </button>
          <button
            type="button"
            style={
              activeMode === MISSION_CONTROL_MODE.DEVELOPMENT
                ? TAB_BUTTON_ACTIVE
                : TAB_BUTTON_BASE
            }
            onClick={() => setActiveMode(MISSION_CONTROL_MODE.DEVELOPMENT)}
          >
            Development
          </button>
        </div>
      )}

      <MissionReadyRenderer onBack={onBack} mode={activeMode} />
    </div>
  );
}
